import React from 'react';
import CardListInformation from '@src/pages/ticketShared/balanceUpload/CardListInformation';
import { VouIdCode } from '@src/store/enums';

const Wrapper = (props) => (
    <CardListInformation vouId={VouIdCode.Compliments} defaultPageSize={10000} {...props} />
);

export default Wrapper;
